import { render } from "./InsuranceClaimsTop.vue?vue&type=template&id=a6942226&scoped=true"
import script from "./InsuranceClaimsTop.vue?vue&type=script&lang=js"
export * from "./InsuranceClaimsTop.vue?vue&type=script&lang=js"

import "./InsuranceClaimsTop.vue?vue&type=style&index=0&id=a6942226&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6942226"]])

export default __exports__